import { Box, Container, Grid, Modal } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, FieldErrors, FieldValues, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import LockResetIcon from '@mui/icons-material/LockReset';

import CustomTypography from '../../../components/Typography/typography';
import CustomTextField from '../../../components/TextField/textField';
import CustomButton from '../../../components/Button/button';
import styles from '../../../assets/styles/resetPassword';
import {
  changePassword,
  userSliceActions,
} from '../../../redux/slice/userSlice';
import ShowPassword from '../../../components/showPassword/ShowPassword';

const ChangePasswordPopUp = (props: any) => {
  const { open, handleClose } = props;
  const [password, setPassword] = useState(false);
  const [newPassword, setnewPassword] = useState(false);
  const classes = styles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ChangepasswordData = useSelector(
    (state: any) => state.user.changePasswordData
  );
  const form = useForm({
    defaultValues: {
      password: '',
      newPassword: '',
    },
  });
  const { formState, handleSubmit, control, clearErrors, reset } = form;
  const { errors, isSubmitting } = formState;

  //submit method that calls change password api
  const onSubmit = async (data: FieldValues) => {
    await dispatch(changePassword({ data, navigate }));
  };

  const onError = (errors: FieldErrors) => {};

  const handleModalClose = () => {
    handleClose();
    dispatch(userSliceActions.clearData());
    clearErrors(['newPassword', 'password']);
    clearErrors('root');
    reset();
  };

  useEffect(() => {
    reset();

    ChangepasswordData?.success && handleModalClose();
  }, [ChangepasswordData]);

  return (
    <Container maxWidth='xs'>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <>
          <Box className={classes.boxClass}>
            <CustomTypography
              id='modal-modal-title'
              align='center'
              variant='h5'
              component='div'
            >
              <LockResetIcon fontSize='large' color='primary' />
            </CustomTypography>
            <CustomTypography
              id='modal-modal-title'
              align='center'
              variant='h5'
              component='h2'
            >
              Change Password
            </CustomTypography>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Grid container className={classes.gridClass} spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='password'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='New Password'
                          type={password ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={password}
                          onClick={() => setPassword(!password)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a new Password',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.password?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='newPassword'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='Confirm Password'
                          type={newPassword ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={newPassword}
                          onClick={() => setnewPassword(!newPassword)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please Re-enter a Password',
                      },
                      minLength: {
                        value: 6,
                        message: 'Confirm password must be 6 character',
                      },
                      maxLength: {
                        value: 20,
                        message:
                          'Confirm password must be less than 20 character',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "New password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.newPassword?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <CustomButton
                  type='submit'
                  fullWidth
                  color='primary'
                  className={classes.customBtnClass}
                  disabled={isSubmitting}
                >
                  {' '}
                  Change Password
                </CustomButton>
              </Grid>
            </form>
            <div onClick={handleModalClose}>
              <CloseIcon
                fontSize='large'
                className={classes.closeIconClass}
                color='primary'
              />
            </div>
          </Box>
        </>
      </Modal>
    </Container>
  );
};

export default ChangePasswordPopUp;
